import React from 'react'
import Button from '../../../../../components/button'
import { useTranslation, Trans } from 'react-i18next'

export default function PracticeCheckPopup({ cancel, continueHandler, serviceValue=0 }) {
    const { t } = useTranslation("mediumBooking");
    return (
        <div
            className="modal"
            id="PracticeCheckPopup"
            role="dialog"
            data-backdrop="false"
        >
            <div className="modal-dialog  modal-lg modal-dialog-preview w-100 Please-check-your-personal-calendar">
                <div className="modal-content margin-top-300 border-waiting-time">
                    <div className="modal-body modal-body-waiting-time">
                        {/* <button type="button" className="close" data-dismiss="modal">
                            &times;
                        </button> */}
{serviceValue != 1 &&
                        <h3 className="text-center mt-5">{t("practiceCheck.message")}</h3>
}
                        {serviceValue == 1 && <h4 className="text-center mt-3"><Trans i18nKey="practiceCheck.messageWithBuffer" ns="mediumBooking" /></h4>}
                        <div>
                            <div className="payment-new-wrapper mt-5">
                                <div className="payment-new-container mt-5">

                                    <div>


                                        <button
                                            className={`resend-btn  min-width-130px`}

                                            onClick={continueHandler}

                                        >
                                            <div> <span> {t("actions.continue")}</span> </div></button>
                                    </div>
                                    <button
                                        className={`resend-btn  min-width-130px model-close-btn`}

                                        onClick={cancel}

                                    >  <div>  <span> {t("actions.cancel")}</span></div></button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
